import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/layout.vue'
import layout2 from '@/layout/layout2.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/login-page/index.vue')
	},
	{
		path: '/redirect',
		name: 'redirect',
		component: () => import('@/views/redirect-page/index.vue')
	},
	{
		path: '/qrcode-pay',
		name: 'qrcode-pay',
		component: () => import('@/views/qrcode-pay/index.vue')
	},
	{
		path: '/result/pay_suc',
		name: 'pay_suc',
		component: () => import('@/views/pay_suc/index.vue')
	},
	{
		path: '/login/face-indentify',
		name: 'face-indentify',
		component: () => import('@/views/login-face-identify/index.vue')
	},
	{
		path: '/sso',
		name: 'sso',
		component: () => import('@/views/login-page/sso.vue')
	},
	{
		path: '/commsso',
		name: 'commsso',
		component: () => import('@/views/login-page/commsso.vue')
	},
	{
		path: '/banknum-checkin-verify/index',
		name: 'banknum-checkin-index',
		component: () => import('@/views/banknum-checkin-verify/index.vue')
	},
	{
		path: '/banknum-checkin/index',
		name: 'banknum-checkin-checkin',
		component: () => import('@/views/banknum-checkin/index.vue')
	},
	/* {
        path: '/result',
        component: layout2,
        redirect: '/result/pay_suc',
        name: 'pay_suc',
        children: [
            {
                path: 'pay_suc',
                name: 'pay_suc',
                component: () => import('@/views/pay_suc/index.vue'),
            },
        ]
    },*/
	{
		path: '/',
		name: 'layout',
		component: Layout,
		redirect: '/redirect',
		children: [
			{
				path: 'home',
				name: 'home',
				component: () => import('@/views/home-page/index.vue')
			},
			{
				path: 'unpaid-fee',
				name: 'unpaid-fee',
				component: () => import('@/views/unpaid-fee/index.vue')
			},
			{
				path: 'choose-fee',
				name: 'choose-fee',
				component: () => import('@/views/choose-fee/index.vue')
			},
			{
				path: 'choose-fee-detail',
				name: 'choose-fee-detail',
				component: () => import('@/views/choose-fee-detail/index.vue')
			},
			{
				path: 'pay-confirm',
				name: 'pay-confirm',
				component: () => import('@/views/pay-confirm/index.vue')
			},
			// {
			//     path: 'pay-ticket',
			//     name: 'pay-ticket',
			//     component: () => import('@/views/pay-ticket/ticketInfo.vue')
			// },
			{
				path: 'pay-confirm-second',
				name: 'pay-confirm-second',
				component: () => import('@/views/pay-confirm-second/index.vue')
			},
			{
				path: 'pay-record',
				name: 'pay-record',
				component: () => import('@/views/pay-record/index.vue')
			},
			{
				path: 'pay-record-detail',
				name: 'pay-record-detail',
				component: () => import('@/views/pay-record-detail/index.vue')
			},
			{
				path: 'pay-refund',
				name: 'pay-refund',
				component: () => import('@/views/pay-refund/index.vue')
			},
			{
				path: 'pay-situation',
				name: 'pay-situation',
				component: () => import('@/views/pay-situation/index.vue'),
				meta: { keepAlive: true }
			},
			{
				path: 'pay-situation-detail',
				name: 'pay-situation-detail',
				component: () => import('@/views/pay-situation-detail/index.vue')
			},
			{
				path: 'pay-situation-download',
				name: 'pay-situation-download',
				component: () => import('@/views/pay-situation-download/index.vue')
			}
		]
	}
]

const router = new VueRouter({
	routes
})

export default router
